import(/* webpackMode: "eager" */ "/home/runner/work/cat-app/cat-app/app/page.tsx");
